import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "store/AuthProvider";
import { StoreContext } from "store/StoreProvider";
import { PickemLayoutPage } from "layouts/PickemLayoutPage";
import { PickemTable } from "components/common/Table/PickemTable";
import { Link } from "react-router-dom";
import { headList } from "./model";
//import { Breadcrumbs } from "components/common/Breadcrumbs";
//import { NoResults } from "components/common/NoResults";
import { Spinner } from "components/common/Spinner/Spinner";
import { withDialog } from "components/common/withDialog/withDialog";
import { TextInput } from "components/common/Form/TextInput/TextInput";
import Checkbox from "components/common/Form/Checkbox/Checkbox";
import { Select } from "components/common/Form/Select/Select";
//import { Select } from "components/common/Form/Select/Select";
import Confirmation from "modals/Confirmation";
import { simpleOptions, options } from "utils/helpers";
import "./PickemSettingsPage.scss";
import { Icon } from "components/common/Icons/Icon";
//const CryptoJS = require("crypto-js");

// PLayer settings: true/false make auto picks for me, logic for default (choose by: random, home team, away team, favorite-home, favorite-away, underdog-home, underdog-away)
// picksetname

//League: non commission show but not change (see commissioner for changes)
//Commish: edit league name, deadline for picks, password, spread on off toggle

//Another section for members (see commissioner if not commish). Show: display name, pickset name, commish: remove button

/**
 * 
 * Time Deadline Options for Compeitions, duplicated in create pickem page
 * 
 */
 const deadlineOptions = simpleOptions([
    "5 minutes before each event start time",
    "5 minutes before first event start time",
    "1 Hour before each event start time",
    "None"
])

/**
 * 
 * Minimum Players Options for Compeitions, duplicated in settings page
 * 
 */
 const minPlayerOptions = simpleOptions([
    ...[2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30,
    32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60,
    62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90,
    92, 94, 96, 98, 100].filter((k) => k >= 8 && k % 2 == 0)
])

const PickemSettingsPage = ({
    history,
    location,
    openModal,
    closeModal,
    match: {
        params: {
            competitionId
        }
    }
    }) => {
    const { functions, accountData, user } = useContext(AuthContext);
    const { updateMeta, competitionData, updateCompetitionData, version } = useContext(StoreContext);
    const [isLoading, setIsLoading] = useState(true);
    const [competitionNameSetting, setCompetitionNameSetting] = useState(null)
    const [competitionDeadlineSetting, setCompetitionDeadlineSetting] = useState(null)
    const [competitionPassword, setCompetitionPassword] = useState(null)
    const [useSpread, setUseSpread] = useState(false)
    const [isCommissioner, setIsCommissioner] = useState(false)
    const [competitionSettings, setCompetitionSettings] = useState(null)
    const [playerData, setPlayerData] = useState(null)
    const [nameString, setNameString] = useState(null)
    const [competitionName, setCompetitionName] = useState(null)
    const [competitionDescription, setCompetitionDescription] = useState(null)
    const [competitionType, setCompetitionType] = useState(null)
    const [picksetName, setPicksetName] = useState(null)
    const [rerunStandings, setRerunStandings] = useState(false)
    const [minPlayers, setMinPlayers] = useState(null)
    const [hideSpread, setHideSpread] = useState(false)
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        updateMeta({
            title: "Settings",
        });
    }, []);

    useEffect(() => {
        if (version.isUpdated) {
            confirm("VersionChange")
        }
    }, [version])

    const getCompetitionSettings = () => {
        functions.httpsCallable('pickemGetCompetitionData')({
            body: JSON.stringify({
                competitionId: competitionId,
            })
        }).then((result) => {
            console.log("Result of Competition:", result.data)
            if (result.data.success) {
                setCompetitionSettings(() => ({...result.data.data}))
            } else {
                if (result.data.message === "Competitor not in competition") {
                    history.push(`/pickem-join/${competitionId}`)
                }
            }
            
        })
    }

    useEffect(() => {
        if (competitionDeadlineSetting && competitionPassword && competitionNameSetting) {
            buildPlayerList()
        }
        
    }, [competitionDeadlineSetting, competitionPassword, competitionNameSetting, isCommissioner, competitionSettings])

    useEffect(() => {
        if (playerData) {
            setIsLoading(false)
            console.log("Player Data:", playerData)
        }
    }, [playerData])

    useEffect(() => {
        if (competitionSettings) {
            console.log(competitionSettings)
            console.log('Context Competition Data:', competitionData )
            setCompetitionDeadlineSetting(competitionSettings.competitionData.deadline)
            setCompetitionPassword(competitionSettings.competitionData.password)
            setCompetitionNameSetting(competitionSettings.competitionData.name)
            setUseSpread(competitionSettings.competitionData.useSpread)
            setCompetitionType(competitionSettings.competitionData.type)
            setIsCommissioner(competitionSettings.competitionData.isCommissioner)
            setMinPlayers(competitionSettings.competitionData.minimumPlayers)
            const picksetData = competitionSettings.competitorData.filter((item) => item.id === user.uid)
            setPicksetName(picksetData[0].picksetName)
        }
    }, [competitionSettings])

    useEffect(() => {
        getCompetitionSettings()
    }, [])

    useEffect(() => {
        if (competitionType === "Baseball" || competitionType === "Hockey") {
            setHideSpread(true)
            setUseSpread(false)
        } else {
            setHideSpread(false)
        }
    }, [competitionType])

    useEffect(() => {
        let name = ""
        if (accountData.firstName && accountData.lastName) {
            name = `${accountData.firstName} ${accountData.lastName}`
        }
        else if (accountData.firstName) {
            name = `${accountData.firstName}`
        }
        else if (accountData.lastName) {
            name = `${accountData.lastName}`
        }
        else if (user.email) {
            name = `${user.email}`
        }
        setNameString(name)
        if (competitionData.competitionDescription) {
            setCompetitionDescription(competitionData.competitionDescription)
        }
        if (competitionData.competitionName) {
            setCompetitionName(competitionData.competitionName)
        }
    }, [competitionData])

    const buildPlayerList = () => {
        //TODO: hyperlink to players picks, display if non commissioner, 
        const players = []
        console.log("BPL: ", competitionSettings)
        for (const player of competitionSettings.competitorData) {
            let name = "-"
            if (player.firstName && player.lastName) {
                name = `${player.firstName} ${player.lastName}`
            }
            else if (player.firstName) {
                name = `${player.firstName}`
            }
            else if (player.lastName) {
                name = `${player.lastName}`
            }
            const compTools = isCommissioner ? (<button onClick={() => handleRemovePlayer(name, player.picksetName, player.id, false)} className="btn-secondary">
                <Icon name={"close"} />
                </button>) : null

            const picksetName = (
                <Link to={{pathname: `/pickem-picks/${competitionId}`}} onClick={() => updateCompetitionData({picksUserId: player.id, isRandomUser: false, shownPicksetName: player.picksetName})}>
                    {player.picksetName}
                </Link>
            )

            const playerObj = {
                name: name,
                picksetName: picksetName,
                competitionTools: compTools,
                id: player.id
            }

            players.push(playerObj)
        }
        if (competitionSettings.randomCompetitorData) {
            for (const random of competitionSettings.randomCompetitorData) {
                const picksetName = (
                    <Link to={{pathname: `/pickem-picks/${competitionId}`}} onClick={() => updateCompetitionData({picksUserId: random.name, isRandomUser: true, shownPicksetName: random.picksetName})}>
                        {random.picksetName}
                    </Link>
                )

                const playerObj = {
                    name: random.name,
                    picksetName: picksetName,
                    id: random.name
                }

                players.push(playerObj)
            }
        }
        setPlayerData(players)
    }

    const handleRemovePlayer = (name, picksetName, uid, isRandom) => {
        confirm("DeleteCompetitor", name, picksetName, uid, isRandom)
    }

    const handleUseSpreadChange = () => {
        if (isCommissioner) {
            setUseSpread(!useSpread)
            setRerunStandings(!rerunStandings)
        }
    }

    const updateStandings = (runAllWeeks, weekNumber) => {
        functions.httpsCallable('pickemGetStandingsPage')({
            body: JSON.stringify({
                competitionId: competitionId,
                runAllWeeks: runAllWeeks,
                currentWeek: weekNumber,
                onlyUpdateStandings: true
            })
        })
    }

    const handleSaveSettings = () => {
        const updateObject = {
            name: competitionNameSetting,
            password: competitionPassword,
            useSpread: useSpread,
            deadline: competitionDeadlineSetting,
            minimumPlayers: minPlayers
        }
        setIsSaving(true)
        functions.httpsCallable("pickemCompetitionUpdate")({competitionId: competitionId, body: JSON.stringify(updateObject)}).then((result => {
            if (result.data.success) {
                const picksetUpdate = {
                    picksetName: picksetName
                }
                if (competitionNameSetting) {
                    updateCompetitionData({competitionName: competitionNameSetting})
                }
                functions.httpsCallable("pickemPicksetUpdate")({competitionId: competitionId, body: JSON.stringify(picksetUpdate)}).then((result) => {
                    if (result.data.success) {
                        confirmSave("SettingsUpdated")
                    } else {
                        confirmSave("SettingsUpdatedFailed")
                    }
                    setIsSaving(false)
                }).catch(() => {
                    confirmSave("SettingsUpdatedFailed")
                    setIsSaving(false)
                })
                updateStandings(true, null)
                
            } else {
                confirmSave("SettingsUpdatedFailed")
                setIsSaving(false)
            }
        }))
    }

    const confirm = (action, name, picksetName, uid, isRandom) => {
        let message = '';
        let title = ''
        switch (action) {
            case 'DeleteCompetitor':
                title = `Remove ${name}`
                message = `Do you want to remove ${name} and their pickset ${picksetName} from ${competitionName}?`
                break
            case 'DeleteCompetition':
                title = `Delete ${competitionName}`
                message = "Do you want to delete this competition?"
                break
            case 'VersionChange':
                title = 'Updated App Version'
                message = "Refresh Now"
                break
            default:
                title = "Error"
                message = "An Error Has Occurred"
                break
        }
        openModal({
            title: title,
            content: (
                <Confirmation
                    message={message}
                    closeModal={closeModal}
                    buttons={true}
                    onConfirm={() => {
                        closeModal();
                            switch (action) {
                                case 'DeleteCompetitor':
                                    deleteCompetitor(competitionId, uid, isRandom)
                                    break
                                case 'DeleteCompetition':
                                    //deleteCompetition(compId)
                                    break
                                case 'VersionChange':
                                    window.location.reload()
                                    break
                            }
                    }}
                />
            ),
        });
    };

    const confirmSave = (action) => {
        let message = '';
        let title = '';
        switch (action) {
            case 'SettingsUpdated':
                title = "Success"
                message = "Settings Successfully Updated"
                break
            case 'SettingsUpdateFailed':
                title = "Error"
                message = "Failed to Update Settings"
                break
            default:
                title = "Error"
                message = "An Error Has Occurred"
        }
        openModal({
            title: title,
            content: (
                <Confirmation
                    message={message}
                    closeModal={closeModal}
                    buttons={false}
                    onConfirm={(e) => {
                        closeModal();
                    }}
                />
            ),
        }, {
            reload: true
        });
    };

    const deleteCompetitor = (compId, uid) => {
        functions.httpsCallable('pickemCompetitionLeave')({
            competitionId: compId,
            userId: uid
        }).then((result) => {
            console.log("Result of Leave:", result.data)
            if (result.data.success) {
                const newCompetitorData = competitionSettings.competitorData.filter((c) => c.id !== uid)
                //const newRandomCompetitorData = competitionSettings.randomCompetitorData.push({})
                setCompetitionSettings(() => ({
                    ...competitionSettings,
                    competitorData: [
                        ...newCompetitorData
                    ]
                }))
            }
            
        })
    }

    return (
        <PickemLayoutPage
            title="Settings"
            name={nameString} 
            competitionName={competitionName} 
            competitionDescription={competitionDescription}
        >
            <div className="PickemSettingsPage">
                {!isLoading && (competitionDeadlineSetting && competitionPassword && competitionNameSetting && playerData && picksetName) ? 
                <div>
                    <h1>Player Settings</h1>
                    <p style={{margin: '0.5em'}}>Pickset Name:</p>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                    <TextInput
                        inputData={{
                            title: "Edit Your Pickset Name",
                            placeholder: "Pickset Name",
                            value: picksetName || "",
                            type: "text",
                        }}
                        code="name"
                        onChange={setPicksetName}
                    />
                    </div>
                    <h1>League Settings</h1>
                    <div className="col">
                    <p style={{margin: '0.5em'}}>League Name:</p>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                    <TextInput
                        inputData={{
                            title: "Enter a League Name",
                            placeholder: "League Name",
                            value: competitionNameSetting || "",
                            type: "text",
                            readOnly: isCommissioner ? null : "readOnly"
                        }}
                        code="name"
                        onChange={isCommissioner ? setCompetitionNameSetting : null}
                    />
                    </div>
                    <p style={{margin: '0.5em'}}>League Password:</p>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                    <TextInput
                        inputData={{
                            title: "Enter a League Password",
                            placeholder: "League Password",
                            value: competitionPassword || "",
                            type: "text",
                            readOnly: isCommissioner ? null : "readOnly"
                        }}
                        code="password"
                        onChange={isCommissioner ? setCompetitionPassword : null}
                    /> 
                    </div>
                    <div hidden={hideSpread} className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                    <Checkbox
                        inputData={{
                            id: 1000,
                            checked: useSpread,
                            name: "Should this league use spread to determine game outcomes?"
                        }}
                        onChange={handleUseSpreadChange}
                    />
                    </div>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                        <p style={{margin: '0.5em 0em'}}>How long prior to start should picks lock:</p>
                        {isCommissioner ? 
                            <Select
                            placeholder="Select Picks Deadline..."
                            title="Deadline"
                            options={deadlineOptions}
                            onChange={setCompetitionDeadlineSetting}
                            optionKey="value"
                            value={competitionDeadlineSetting}
                            code="deadline"
                        /> : 
                        <TextInput
                            inputData={{
                                title: "League Deadline",
                                placeholder: "League Deadline",
                                value: competitionDeadlineSetting || "",
                                type: "text",
                                readOnly: "readOnly"
                            }}
                            code="deadline"
                            onChange={null}
                        />
                        }
                    </div>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                        <p>Minimum Number of Players:</p>
                        <Select
                            placeholder="Select Minimum Players..."
                            title="MinPlayers"
                            options={minPlayerOptions}
                            onChange={setMinPlayers}
                            optionKey="value"
                            value={minPlayers}
                            code="minPlayers"
                        />
                           
                    </div>
                    <div className="PickemSettingsPage-leagueinfo" style={{margin: '0.5em'}}>
                        {isCommissioner ? <button onClick={handleSaveSettings} style={{ fontSize: "1em", marginTop: "1em" }}
                            className={`btn-primary${isSaving ? " spinning" : ""}`}
                        >
                            {isSaving ? "" : "Save"}
                        </button> : null }
                    </div>
                    <h1>Players</h1>
                    {playerData && <PickemTable
                    subject="players"
                    headList={headList}
                    list={playerData}
                    selected={[]}
                    />}
                </div>
                
            </div>
                : <Spinner></Spinner>}
            </div>
            
        </PickemLayoutPage>
    );
};

export default withDialog(PickemSettingsPage);
